import DataSize from './enums/dataSize/DataSize';

export default function convertDataSize(from: number, fromSize: DataSize, toSize: DataSize) {
  if (from === 0) return 0;
  const fromIndex = Object.values(DataSize).indexOf(fromSize);
  const toIndex = Object.values(DataSize).indexOf(toSize);
  const bytes = from * Math.pow(1000, fromIndex);
  return bytes / Math.pow(1000, toIndex);
}
